import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { FormImagePreview } from '../../../shared/ui/formImagePreview'

interface SortableImageProps {
  id: string;

  index: number;

  remove: (index: number) => void;

  isMain?: boolean;
}

export const SortableImage = ({id, index, remove}: SortableImageProps) => {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id})

  const style = {
    transform: CSS.Transform.toString(transform),
    transformOrigin: '0 0',
    transition,
    cursor: isDragging ? 'grabbing' : 'grab',
    ...(index === 0
        ? {
        height: 416,
        gridRowStart: 'span 2',
        gridColumnStart: 'span 2'

      }
        : {
        width: '100%',
        height: 200
      })
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <FormImagePreview
        name={`images.${index}`}
        onRemove={() => remove(index)}
        isMain={index === 0}
      />
    </div>
  )
}
